import React from 'react';
import { Link } from 'react-router';
import Contact from './contact';

const NavBar = ({ onToggleMenu }) => {
    return (
        <div className="d-flex flex-column w-100 pb-4 menu pt-2" style={{ zIndex: 10 }}>
            <i className="w3-bar-item w3-button w3-padding-large block text-right fa fa-times font-20 white" onClick={onToggleMenu} />
            <Link to="/" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">HOME</Link>
            <Link to="/new" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">WHAT'S NEW</Link>
            <Link to="/tournaments" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">TOURNAMENTS</Link>
            <Link to="/passport" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">PASSPORT</Link>
            <Link to="/rankings" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">RANKINGS</Link>
            <Link to="/information" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">INFORMATION</Link>
            <Link to="/contact" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">CONTACT</Link>
            <Link to="/faqs" className="w3-bar-item w3-button w3-padding-large block text-left hind font-30">FAQ</Link>
            <div className="mt-auto force"><Contact /></div>
        </div>
    );
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/layouts/burger.js